<template>
  <div class="calendar-day">
    <div class="calendar-day__wrapper" ref="calendarDay">
      <div class="calendar-day__row">
        <!-- CALENDAR SLIDER START  -->
        <swiper :options="swiperOption" ref="mySwiper" @slideChange="callback">
          <swiper-slide v-for="day in monthDays" :key="day.id">
            <!-- CALENDAR SLIDER ITEM START  -->
            <div class="calendar-day__item">
              <!-- CALENDAR SLIDER ITEM HEAD START  -->
              <div class="row row_header">
                <div class="row__name row__name_w156 row__name_dark">
                  <span
                    class="swiper-button-prev"
                    slot="button-prev"
                    @click="prevSlide"
                    v-show="!isBeginning"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.31396 10.7859L12.2778 16.0404C12.66 16.4451 13.3039 16.4451 13.6862 16.0404C14.0386 15.6673 14.039 15.0841 13.6869 14.7107L9.98738 10.7859L13.6869 6.8611C14.039 6.48764 14.0386 5.90444 13.6862 5.53136C13.3039 5.12669 12.66 5.12669 12.2778 5.53136L7.31396 10.7859Z"
                        fill="var(--menu-text-color)"
                      />
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="7"
                        y="5"
                        width="7"
                        height="12"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.31396 10.7859L12.2778 16.0404C12.66 16.4451 13.3039 16.4451 13.6862 16.0404C14.0386 15.6673 14.039 15.0841 13.6869 14.7107L9.98738 10.7859L13.6869 6.8611C14.039 6.48764 14.0386 5.90444 13.6862 5.53136C13.3039 5.12669 12.66 5.12669 12.2778 5.53136L7.31396 10.7859Z"
                          fill="var(--menu-text-color)"
                        />
                      </mask>
                      <g mask="url(#mask0)" />
                    </svg>
                  </span>
                  <span>{{ getCurrentDate(day.date) }}</span>
                  <span
                    class="swiper-button-next"
                    slot="button-next"
                    @click="nextSlide"
                    v-show="!isEnd"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.6162 10.5161L9.65242 5.26152C9.27014 4.85685 8.62625 4.85685 8.24397 5.26152C7.89154 5.6346 7.89122 6.2178 8.24325 6.59127L11.9428 10.5161L8.24325 14.4408C7.89122 14.8143 7.89154 15.3975 8.24397 15.7706C8.62625 16.1753 9.27014 16.1753 9.65242 15.7706L14.6162 10.5161Z"
                        fill="var(--menu-text-color)"
                      />
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="7"
                        y="4"
                        width="8"
                        height="13"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.6162 10.5161L9.65242 5.26152C9.27014 4.85685 8.62625 4.85685 8.24397 5.26152C7.89154 5.6346 7.89122 6.2178 8.24325 6.59127L11.9428 10.5161L8.24325 14.4408C7.89122 14.8143 7.89154 15.3975 8.24397 15.7706C8.62625 16.1753 9.27014 16.1753 9.65242 15.7706L14.6162 10.5161Z"
                          fill="var(--menu-text-color)"
                        />
                      </mask>
                      <g mask="url(#mask0)" />
                    </svg>
                  </span>
                </div>

                <calendar-day-time :isHead="true" />

                <div class="statistic2 statistic2_head">
                  <div class="statistic2-row">
                    <p>{{ $t("metrics.booked") }}</p>
                  </div>
                  <div class="statistic2-row">
                    <p>{{ $t("metrics.workload") }}</p>
                  </div>
                  <div class="statistic2-row">
                    <p>{{ $t("metrics.discipline") }}</p>
                  </div>
                  <div class="statistic2-row">
                    <p>{{ $t("metrics.factual_workload") }}</p>
                  </div>
                </div>
              </div>
              <!-- CALENDAR SLIDER ITEM HEAD END  -->

              <div class="list">
                <div v-if="view === 'services'">
                  <calendar-schedule :masters="masters" />
                </div>

                <template v-if="day.requests && view !== 'services'">
                  <!-- CALENDAR DAY NEW REQUESTS START  -->
                  <template
                    v-if="
                      day.requests['new'] &&
                        view !== 'services' &&
                        $route.query.master == null
                    "
                  >
                    <calendar-day-new-item
                      class="row row--new"
                      v-for="request in day.requests['new']"
                      :key="request.id"
                      :request="request"
                      :view="view"
                    />
                  </template>

                  <!-- CALENDAR DAY APPROVED REQUESTS START  -->
                  <template
                    v-if="day.requests['approved'] && view !== 'services'"
                  >
                    <calendar-day-item
                      v-for="approved in day.requests['approved']"
                      :key="approved.id"
                      :style="{
                        height: approved.requests.length * 15 + 'px',
                      }"
                      :view="view"
                      :approved="approved"
                      :detail="detail"
                    />
                  </template>
                  <!-- CALENDAR DAY APPROVED REQUESTS START  -->
                </template>
              </div>
            </div>
            <!-- CALENDAR SLIDER ITEM END  -->
          </swiper-slide>
        </swiper>
        <!-- CALENDAR SLIDER START  -->

        <!-- CALENDAR SLIDER (PREV, NEXT) START  -->
        <!-- <div class="swiper-button-prev" slot="button-prev" @click="prevSlide" v-show="!isBeginning"></div> -->
        <!-- <div class="swiper-button-next" slot="button-next" @click="nextSlide" v-show="!isEnd"></div> -->
        <!-- CALENDAR SLIDER (PREV, NEXT) END  -->
      </div>
    </div>

    <!-- DELETE MODAL START  -->
    <modal :show="showModalDelete" @close="closeModal" :dark="true">
      <delete-modal :cancelAction="closeModal" :okAction="deleteConfirm">{{
        $t("calendar.deleteTitle")
      }}</delete-modal>
    </modal>
    <!-- DELETE MODAL END  -->

    <modal :show="showModal" @close="toggleModal" :dark="true" :outside="false">
      <transition name="showmodal">
        <orders-modal />
      </transition>
    </modal>

    <snackbar
      v-if="snackbar.show"
      :message="$t('forms.snackbarMessage')"
      @reopen="reopen"
      @close="closeSnackbar"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import calendarDayItem from '@/components/calendars/day/calendarDayItem'
import calendarSchedule from '@/components/calendars/day/calendarSchedule'
import calendarDayNewItem from '@/components/calendars/day/calendarDayNewItem'
import calendarDayTime from '@/components/calendars/day/calendarDayTime'
import ordersModal from '@/components/modals/orders/ordersModal'
import snackbar from '@/components/controls/snackbar'

import getColor from '@/mixins/getStatisticColors'

export default {
    props: [
        'monthDays',
        'detail',
        'getDetails',
        'requestDetail',
        'updateRequest',
        'deleteRequest',
        'view',
        'active',
    ],
    components: {
        swiper,
        swiperSlide,
        calendarDayItem,
        calendarDayNewItem,
        ordersModal,
        calendarSchedule,
        snackbar,
        calendarDayTime,
    },
    mixins: [getColor],
    filters: {
        filterTime(time) {
            const filtred = moment(time * 1000).format('HH:mm')
            return filtred
        },
    },
    data() {
        return {
            swiperOption: {
                init: true,
                slidesPerView: 1,
                spaceBetween: 0,
                nested: false,
                initialSlide: this.detail - 1,
                simulateTouch: false,
            },
            showModalDelete: false,
            requestId: null,
            masters: null,
            isBeginning: false,
            isEnd: false,
            isOpenModal: false,
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        showDetails: {
            get() {
                return this.$store.state.calendar.showDetails
            },
            set(data) {
                this.$store.state.calendar.showDetails = data
            },
        },
        ...mapGetters({
            showModal: 'orders/showModal',
            dayGetters: 'dayGetters',
            service: 'serviceGetters',
            dayMetricsGetters: 'dayMetricsGetters',
            services: 'servicesGetters',
            snackbar: 'orders/snackbar',
        }),
    },
    watch: {
        dayGetters(v) {
            this.updateMetrics(v)
        },
    },
    methods: {
        ...mapMutations({
            toggleModal: 'orders/setToggleModal',
            setDay: 'setDay',
            setState: 'metrics/setState',
            setDayMetrics: 'metrics/setDayMetrics',
            setSnackbarShow: 'orders/setSnackbarShow',
        }),
        ...mapActions({
            fetch: 'schedule/fetch',
            fetchById: 'orders/fetchById',
        }),
        async nextSlide() {
            const date = new Date(this.dayGetters)
            this.setDay(new Date(date.setDate(date.getDate() + 1)))
            await this.prepareSchedule()

            this.swiper.slideNext()
        },
        async prevSlide() {
            const date = new Date(this.dayGetters)
            this.setDay(new Date(date.setDate(date.getDate() - 1)))
            await this.prepareSchedule()

            this.swiper.slidePrev()
        },
        callback() {
            this.isBeginning = this.swiper.isBeginning
            this.isEnd = this.swiper.isEnd
        },
        getCurrentDate(date) {
            const currentDate = new Date(date)
            const day = currentDate.getDate() < 10
                ? `0${currentDate.getDate()}`
                : currentDate.getDate()
            const month = currentDate.getMonth() + 1 < 10
                ? `0${currentDate.getMonth() + 1}`
                : currentDate.getMonth() + 1

            return `${day}.${month}`
        },
        deleteConfirm() {
            this.showDetails = false
            this.$emit('deleteRequest', this.requestId)
        },
        closeModal() {
            this.showModalDelete = false
        },
        async prepareSchedule() {
            const dt = new Date(new Date(this.dayGetters).setHours(9))
            // const day = dt.getTime() / 1000;

            const nd = moment(dt).format('YYYY-MM-DD')
            const technicians = await this.fetch({ type: 'masters', day: nd })
            // const engineers = await this.fetch({type: 'engineers', day});
            this.masters = technicians
            if (this.$route.query.master) {
                this.masters = this.masters.filter(
                    (item) => item.master.id === this.$route.query.master,
                )
            }
        },
        updateMetrics(v) {
            this.setState({
                key: 'view',
                value: 'day',
            })
            const datt = new Date(v)

            const summator = this.$config.mode === 'prod' ? 1 : 0
            const key = datt.setHours(datt.getHours() + summator).valueOf() / 1000

            this.setState({
                key: 'dayKey',
                value: key,
            })

            this.setDayMetrics()
        },
        getColor(request) {
            let color = '#000'

            this.services.forEach((element) => {
                if (element.id === request.service_id) {
                    color = element.color
                }
            })

            return color
        },
        async reopen() {
            const { id } = this.snackbar.data
            await this.fetchById(id)
            this.toggleModal()
            this.setSnackbarShow(false)
        },
        closeSnackbar() {
            this.setSnackbarShow(false)
        },
    },
    async created() {
        await this.prepareSchedule()
        this.updateMetrics(this.dayGetters)
        this.callback()
    },
    beforeDestroy() {
        const slider = document.querySelector('.calendar-day__wrapper')
        slider.innerHTML = ''
        this.closeSnackbar()
    },
}
</script>

<style lang="scss">
@import "src/assets/sass/main";
.row {
  position: relative;
  height: 40px;
  display: flex;
  border-bottom: solid 1px var(--border-color);

  &_header {
    .row__name {
      font-size: 24px;
      color: var(--menu-text-color);

      &_dark {
        background-color: var(--bg-color);
      }
    }
  }
  &__name {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: $fontMedium;
    color: var(--menu-text-color);
    max-width: 120px;
    width: 100%;
    border-right: 1px solid var(--border-color);
    background-color: var(--bg-color2);
    text-transform: uppercase;

    @include respond(desktop) {
      font-size: 14px;
    }

    &_w156 {
      min-width: 156px;
    }
  }

  &__stats {
    max-width: 290px;
    min-width: 150px;
    width: 100%;
    z-index: 999999999999;
    background-color: var(--bg-color2);
    display: flex;
    align-items: center;
    padding-left: 5px;
    box-sizing: border-box;
  }

  &__times {
    position: relative;
    width: 100%;
    display: flex;

    & .time {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% / 10);
      color: var(--label-color);
      font-family: $fontMedium;
      font-size: 11px;
      line-height: 24px;
      box-sizing: border-box;
      min-width: 45px;
      position: relative;
      border-right: 1px solid var(--border-color);
      // margin: 4px 0;
      // &::before {
      //     position: absolute;
      //     content: '';
      //     border-left: 1px solid rgba(77, 77, 77, 0.3);
      //     z-index: 5;
      //     height: 100%;
      //     left: 0;
      //     width: 1px;
      //  }

      @include respond(desktop) {
        min-width: 39px;
        font-size: 13px;
      }

      // &:last-child {
      //     &::after {
      //         position: absolute;
      //         content: '';
      //         border-right: 1px solid rgba(77, 77, 77, 0.5);
      //         z-index: 5;
      //         height: 100%;
      //         right: 0;
      //         width: 2px;
      //     }
      // }
    }
  }

  &--new {
    cursor: pointer;

    & .row__name {
      font-size: 10px;
      display: flex;
      justify-content: flex-start;
      padding-left: 12px;

      svg {
        margin-right: 6px;
      }
    }
    //   justify-content: flex-start;
    //   border-top: 1px solid #71bd4a;
    //   padding-left: 16px;
    //   box-sizing: border-box;
    //   color: #4d4d4d;
    //   font-size: 10px;

    // }

    // & .time span {
    //   display: block;
    //   width: 100%;
    //   height: 100%;
    //   background-color: rgba(#71bd4a, 0.1);
    // }

    & .request {
      position: absolute;
      z-index: 9999999999;
      margin-left: 4%;
      margin-top: 4px;
    }
    //   position: absolute;
    //   top: 9px;
    //   height: 30px;
    //   border-radius: 8px;
    //   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    //   background-color: #71bd4a;
    //   color: #ffffff;
    //   font-size: 12px;
    //   font-family: $fontBold;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   text-align: center;
    //   width: 40px;
    // }
  }

  &--service {
    height: auto;
    min-height: 40px;

    & .row__name {
      font-size: 10px;
      padding-left: 12px;
      display: flex;
      justify-content: flex-start;

      & img {
        margin-right: 6px;
        width: 16px;
      }
    }

    & .line {
      position: absolute;
      display: inline-block;
      height: 4px;
      cursor: pointer;
      transition: 0.5s;
      border-radius: unset;
      z-index: 3;
      // height: 2px;
      // display: inline-block;
      // width: 80%;
      // margin-top: 16px;
    }
  }

  &--image {
    width: 24px;
    height: 24px;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0;
  }
}

.calendar-day {
  width: 100%;
  display: flex;
  max-width: 100%;

  &__wrapper {
    position: relative;
    justify-content: center;
    box-sizing: border-box;
    flex-shrink: 1;
    flex-grow: 1;
    width: 100%;
  }

  &__request {
    flex-shrink: 0;
    max-width: 430px;
    width: 100%;
    @include respond(desktop) {
      max-width: 310px;
    }
  }

  &__row {
    width: 100%;
    overflow: hidden;
  }

  &__item {
    width: 100%;
    height: max-content;
    max-height: 830px;
    overflow: hidden;
    background-color: var(--bg-color2);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    // overflow-y: auto;
  }

  .swiper-button-prev {
    position: absolute;
    left: 0px;
    background-image: unset;
    width: 22px;
    height: 22px;
    margin-top: 0;
    top: 8px;
  }

  .swiper-button-next {
    position: absolute;
    right: 0px;
    background-image: unset;
    width: 22px;
    height: 22px;
    margin-top: 0;
    top: 8px;
  }

  .client-cart {
    position: absolute;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    margin-bottom: 10px;
    overflow: hidden;
    top: 6px;
    cursor: pointer;

    &__wrapper {
      display: flex;
      padding: 6px 10px 16px 10px;
      flex-direction: column;
      overflow: hidden;
    }

    &__image {
      width: 30px;
      height: 30px;
      border: solid 1px $secondColor;
      background-size: cover;
      background-position: center;
      border-radius: 50%;
      margin-right: 16px;
      flex-shrink: 0;

      &-wrapper {
        display: flex;
        margin-bottom: 12px;
      }
    }

    &__text {
      flex-grow: 1;
      max-width: 100%;
      overflow: hidden;
    }

    &__name {
      color: #4d4d4d;
      font-size: 10px;
      font-family: $fontBold;
      margin-bottom: 2px;
    }

    &__time {
      font-size: 10px;
      color: #00d8ff;
      margin-bottom: 5px;
    }

    &__phone {
      color: #4d4d4d;
      font-size: 10px;
      margin-bottom: 5px;
    }

    &__email {
      color: #4d4d4d;
      font-size: 10px;
      margin-bottom: 5px;
    }

    &__address {
      color: #4d4d4d;
      font-size: 10px;
      margin-bottom: 5px;
      text-decoration: underline;
      font-family: $fontBold;
    }

    &__media {
      display: flex;
      align-items: stretch;
      flex-wrap: wrap;

      &-item {
        width: 100%;
        max-width: 46px;
        height: 30px;
        background-color: #4d4d4d;
        margin-right: 4.5px;
        margin-bottom: 4.5px;
      }
    }
  }
}

.statistic2 {
  max-width: 290px;
  min-width: 150px;
  width: 100%;
  z-index: 999999999999;
  background-color: var(--bg-color2);
  display: flex;
  box-sizing: border-box;
  padding: 0 5px;

  &-row {
    width: 25%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--label-color);
    font-size: 7px;
    text-align: center;

    &:not(&:last-child) {
      border-right: 1px solid var(--border-color);
    }

    &__box {
      width: 32px;
      height: 100%;
      padding: 4px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    &__percent {
      width: 8px;
      height: 100%;
    }

    &__percent-text {
      font-size: 9px;
      line-height: 12px;
      margin-top: 2px;
    }
  }
}

.statistic {
  color: var(--label-color);
  font-size: 11px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: flex-end;
  background-color: var(--bg-color2);
  z-index: 4;

  &-item {
    display: flex;
    flex-direction: column;
    width: 22px;
    margin: 4px 0;
    height: calc(100% - 8px);

    &:not(:last-child) {
      margin-right: 35px;
    }

    &_text {
      color: rgba(77, 77, 77, 0.8);
      font-size: 11px;
    }

    &__p {
      &_ok {
        color: #ffc100;
      }

      &_bad {
        color: #ff3100;
      }

      &_so-so {
        color: #f07300;
      }

      &_good {
        color: var(--bg-color-green);
      }

      &_awesome {
        color: #3493ff;
      }
    }

    &__box {
      height: 90%;
      display: flex;
      align-items: flex-end;

      &_actual {
        width: 100%;
        background-color: #ffc100;
      }

      &_online {
        width: 100%;
        background-color: var(--bg-color-green);
      }

      &_execution {
        width: 100%;
        background-color: #3493ff;
      }

      &_orders {
        width: 100%;
      }

      div {
        max-height: 100%;
      }
    }

    p {
      height: 10%;
      margin: 0;
      margin-top: 5px;
    }
  }
}

.statistic-item_text {
  font-size: 9px;
}

.statistic_head {
  align-items: center;
  font-size: 11px;

  .statistic-item_text {
    color: var(--label-color);
  }
  .statistic-item {
    height: auto !important;
  }
}

.statistic-item {
  width: auto;
  // margin: 9px 0;
  text-align: center;

  &:last-child {
    word-break: break-word;
  }
}

.statistic-item:not(:last-child) {
  margin-right: 20px;
}

.master {
  &-schedule {
    width: 100%;
    width: 100%;
    background-color: rgba(155, 205, 130, 0.3);
    position: absolute;
    left: 0;
    height: 38px;
    top: 1px;
  }

  &-online {
    background-color: #da7dd7;
    position: absolute;
    bottom: 0;
    z-index: 4;
    height: 3px;
  }

  &-order {
    cursor: pointer;
    background-color: rgba(#50af3c, 1);
    position: absolute;
    top: 2px;
    bottom: 16px;
    z-index: 1;
    height: 90%;

    &__actual {
      background-color: rgba(#50af3c, 0.9);
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &__late {
      right: 0;
      width: 10%;
      height: 100%;
      background-color: red;
      position: absolute;
      top: 0;
    }
  }
}

.calendar-day {
  height: 100%;

  &__row {
    height: 100%;

    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
      z-index: 1;
      height: 100%;
    }

    .list {
      height: 82vh;
      overflow-y: auto;
    }
  }
}
</style>
